import React from 'react';
import { TabPanel, Text } from "@chakra-ui/react";

const Admins = () => {
    return (
        <TabPanel>
            <Text>Admins</Text>
        </TabPanel>
    );
};

export default Admins;